import React from 'react';

// Two-tone headline: first part in ink, second in ghost grey (rgb(181,181,181)).
//  "Log in to" / "your account."   "Your Cart is" / "Empty"   "All-Access is" / "Live"
type Size = 'hero' | 'hero-sm' | 'title';

const SIZES: Record<Size, string> = {
    hero: 'text-hero',
    'hero-sm': 'text-hero-sm',
    title: 'text-title',
};

export function Headline({
    lead,
    trail,
    size = 'hero',
    as: Tag = 'h1',
    stacked = false,
    className = '',
}: {
    lead: React.ReactNode;
    trail?: React.ReactNode;
    size?: Size;
    as?: 'h1' | 'h2';
    // Force each part onto its own line (auth headlines: "Log in to" / "your account.")
    stacked?: boolean;
    className?: string;
}) {
    return (
        <Tag className={`font-bold text-ink ${SIZES[size]} ${className}`}>
            {stacked ? (
                <>
                    <span className="block">{lead}</span>
                    {trail !== undefined && <span className="block text-ghost">{trail}</span>}
                </>
            ) : (
                <>
                    {lead}
                    {trail !== undefined && (
                        <>
                            {' '}
                            <span className="text-ghost">{trail}</span>
                        </>
                    )}
                </>
            )}
        </Tag>
    );
}

export default Headline;
